import {ChangeDetectionStrategy, Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {
  marketingSubscribe,
  selectDeviceIsSmallScreen,
  StripePaymentSelectionService
} from '@spout/global-web/data-access';

@Component({
  selector: 'spt-subscribe',
  templateUrl: './page-subscribe.component.html',
  styleUrls: ['./page-subscribe.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageSubscribeComponent implements OnInit {
  deviceIsSmall$ = this._store.pipe(select(selectDeviceIsSmallScreen));

  constructor(
    private _store: Store,
    public payment: StripePaymentSelectionService
  ) {}

  ngOnInit() {
    this.payment.init(()=>{
    this._store.dispatch(marketingSubscribe());
    });
  }
}
